import { render, staticRenderFns } from "./WTable.vue?vue&type=template&id=c873b964&scoped=true&"
import script from "./WTable.vue?vue&type=script&lang=js&"
export * from "./WTable.vue?vue&type=script&lang=js&"
import style0 from "./WTable.vue?vue&type=style&index=0&id=c873b964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c873b964",
  null
  
)

export default component.exports